import {TDDFilterExpressionDto} from 'features/predicate-expression-form-list';
import {performRequest} from 'shared/utils';

const ddFilterConstructorApiEndpoint = '/table-reports/drill-filter';

export interface IFetchDrillDownFilterByIdArgs {
    drillId: number;
}

export const fetchDrillDownFilterById = (
    {drillId}: IFetchDrillDownFilterByIdArgs,
) => performRequest<TDDFilterExpressionDto>({
    url: [ddFilterConstructorApiEndpoint, drillId].join('/'),
    method: 'GET',
});

export interface IPostDrillDownFilterByIdArgs {
    drillId: number;
    filter: TDDFilterExpressionDto;
}

export const postDrillDownFilterById = ({drillId, filter}: IPostDrillDownFilterByIdArgs) => performRequest<string>({
    url: [ddFilterConstructorApiEndpoint, drillId].join('/'),
    method: 'POST',
    data: filter,
});

export interface IDeleteDrillDownFilterByIdArgs {
    drillId: number;
}

export const deleteDrillDownFilterById = ({drillId}: IDeleteDrillDownFilterByIdArgs) => performRequest<string>({
    url: [ddFilterConstructorApiEndpoint, drillId].join('/'),
    method: 'DELETE',
});
